import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '../../services/message.service';
import { UtilService } from 'src/app/util/util.service';
import { LocalStorageService } from '../../services/localStorage.service';
import { ApiService } from '../../services/api.service';
import { REVERT_ICON } from 'src/defaultImages.js';

@Component({
  selector: 'app-revert-order',
  templateUrl: './revert-order.component.html',
  styleUrls: ['./revert-order.component.css'],
})
export class RevertOrderComponent implements OnInit, OnDestroy {
  images: any = {
    REVERT_ICON: REVERT_ICON,
  };
  subscription = new Subscription();
  loading: boolean = false;
  translationText: any;

  constructor(
    public _dialogRef: MatDialogRef<any>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _translateService: TranslateService,
    private _msgService: MessageService,
    private _utilService: UtilService,
    private _localStorage: LocalStorageService,
    private _apiService: ApiService
  ) {}

  ngOnInit() {
    this.subscription.add(
      this._translateService.get(['REVERT_ORDER']).subscribe((translation) => {
        this.translationText = translation.REVERT_ORDER;
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  closeModal() {
    this._dialogRef.close({ status: 0, data: null, message: 'closed' });
  }

  cancelClicked() {
    this.closeModal();
  }

  revertClicked() {
    const currOrderDetails = (this.data || {}).currOrderDetails || {};
    const payload = {
      order_id: currOrderDetails.order_id,
      status: 3,
      reverted_by: this._utilService.getUserName(),
      timezone: this._localStorage.get('time_zone'),
    };
    this.loading = true;
    this._apiService.revertOrder(payload).subscribe(
      (res: any) => {
        this.loading = false;
        if ((res || {}).statusCode == 200) {
          this._msgService.showSuccess(
            this.translationText.REVERTED_SUCCESSFULLY
          );
        } else {
          this._msgService.handleErrors(res?.error?.message);
        }
        this._dialogRef.close({ status: 1, data: null, message: 'reverted' });
      },
      (error) => {
        this.loading = false;
        this.closeModal();
        this._msgService.handleErrors(error?.error?.message);
      }
    );
  }
}
